// extracted by mini-css-extract-plugin
module.exports = {"pros-cons-input":"styles-module__pros-cons-input___3YC3w"};